"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var CrossCircleFill = function CrossCircleFill(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    viewBox: "0 0 24 24",
    height: "20px",
    width: "20px"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M20.488 3.515c-4.686-4.682-12.28-4.678-16.962.008s-4.678 12.28.008 16.962c4.683 4.679 12.271 4.679 16.954 0 4.678-4.689 4.678-12.281 0-16.97zm-3.779 11.764a1 1 0 01-1.409 1.415l-3.11-3.11a.252.252 0 00-.354 0l-3.109 3.11a1.019 1.019 0 01-1.415 0 1 1 0 01-.001-1.414l.001-.001 3.11-3.109a.25.25 0 00.001-.352l-.001-.001-3.11-3.11a1 1 0 011.41-1.415l3.109 3.11a.25.25 0 00.354 0l3.11-3.11a1 1 0 011.414 1.415l-3.11 3.11a.25.25 0 000 .353l3.11 3.109z"
  }));
};
CrossCircleFill.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
CrossCircleFill.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = CrossCircleFill;